// @flow
import SMConst from 'frontend_core/dist/constants/sm-const'
import ReservationModel from 'frontend_core/dist/model/Reservation'

import Path from 'routes/path'
import { type ReservationType } from 'types/v1/reservation'
import { getBillStatementCurrentProps } from 'components/molecules/BillStatementCurrent/presenter'
import { getReservationDateProps } from 'components/molecules/ReservationDate/presenter'
import { getReservationGetPointBlockPropsOnlyNext } from 'components/molecules/ReservationGetPointBlock/presenter'

import { type PropTypes } from './index'

export function getReservationDetailSectionProps(
  reservation: ReservationType,
  onClickLink: (e?: ?Event, url: string, newWindow?: boolean) => void,
): PropTypes {
  const reservedRoom = reservation.room || {}
  const reservedBilling = reservation.billing || {}

  const spaceUrl = reservedRoom.id
    ? Path.room(reservedRoom.space.username, reservedRoom.uid)
    : null

  // JSTの時間をISO表記で送られてくるため9時間マイナスする(spmkt_webより移植)
  const changeEndedAt = reservation.ended_at
    ? new Date(
        new Date(reservation.ended_at).getTime() -
          reservedRoom.space.utc_offset * 1000,
      )
    : null
  if (changeEndedAt) {
    changeEndedAt.setDate(changeEndedAt.getDate() + 1)
  }

  const hasChangeRequestFromOwner = ReservationModel.hasChangeRequestFromOwner(
    reservation,
  )
  const hasChangeRequestFromUser = ReservationModel.hasChangeRequestFromUser(
    reservation,
  )

  let reservationDetailStatus = ''
  if (hasChangeRequestFromOwner) {
    reservationDetailStatus = 'hasChangeRequestFromHost'
  } else if (hasChangeRequestFromUser) {
    reservationDetailStatus = 'hasChangeRequest'
  } else if (reservation.status === SMConst.ReservationStatus.Paying) {
    reservationDetailStatus = 'paying'
  } else if (
    reservation.status === SMConst.ReservationStatus.Confirmed ||
    reservation.status === SMConst.ReservationStatus.Paid ||
    reservation.status === SMConst.ReservationStatus.Postpay
  ) {
    reservationDetailStatus = 'confirmed'
  } else if (
    reservation.status === SMConst.ReservationStatus.Sent ||
    reservation.status === SMConst.ReservationStatus.EntrustedOwner ||
    reservation.status === SMConst.ReservationStatus.Requested
  ) {
    reservationDetailStatus = 'hasRequest'
  }

  return {
    spaceImageUrl:
      (reservedRoom.thumbnails &&
        reservedRoom.thumbnails[0] &&
        reservedRoom.thumbnails[0].image) ||
      '',
    spaceUrl,
    spaceName: reservedRoom.name || '',
    ...getReservationDateProps(reservation),
    paymentMethod:
      reservedBilling.destination_type == SMConst.BillingDestinationType.Company
        ? i18n.t('page.dashboard.reservation.chargeCompany', {
            companyName: (reservedBilling.company || {}).name || '',
          })
        : reservedBilling.payment_method_text || '',
    onClickChangeCreditCard: reservation.can_change_card
      ? e => onClickLink(e, Path.reservationChangePayment(reservation.uid))
      : undefined,
    billStatementCurrentProps: getBillStatementCurrentProps(reservation),
    reservationGetPointBlockProps: getReservationGetPointBlockPropsOnlyNext(
      reservation,
    ),
    changeEndedAt,

    canBeCancelled: reservation.can_be_cancelled,
    canBeEdited: reservation.can_be_edited,
    hasChangeRequestFromOwner,
    hasChangeRequestFromUser,
    onClickCancel: e => onClickLink(e, Path.reservationCancel(reservation.uid)),
    onClickChangeReservation: e =>
      onClickLink(e, Path.reservationEdit(reservation.uid)),
    onClickConfirmChangeReservation: e =>
      onClickLink(e, Path.reservationChangeGuest(reservation.uid)),
    onClickConfirmChangeReservationFromHost: e =>
      onClickLink(e, Path.reservationChangeHost(reservation.uid)),
  }
}



// WEBPACK FOOTER //
// ./src/components/organisms/ReservationDetailSection/presenter.js